import {
    addDays,
    endOfQuarter,
    endOfYear,
    startOfQuarter,
    startOfYear,
    subDays,
    subQuarters,
    subYears,
} from 'date-fns';

export const PRACTICE_PULSE_PERIOD_STORAGE_KEY = 'dashboard2-practice-pulse-period';

export const PRACTICE_PULSE_PERIOD_OPTIONS = [
    'YTD',
    'Past 7 Days',
    'Past 30 Days',
    'Past 12 Months',
    'This Quarter',
    'Last Quarter',
    'Last Year',
] as const;

export type PracticePulsePeriod = (typeof PRACTICE_PULSE_PERIOD_OPTIONS)[number];

export const DEFAULT_PRACTICE_PULSE_PERIOD: PracticePulsePeriod = 'YTD';

export interface PracticePulseDateRange {
    from: Date;
    to: Date;
}

export const isPracticePulsePeriod = (value: string | null | undefined): value is PracticePulsePeriod =>
    PRACTICE_PULSE_PERIOD_OPTIONS.some((option) => option === value);

export const normalizePracticePulsePeriod = (value: string | null | undefined): PracticePulsePeriod =>
    isPracticePulsePeriod(value) ? value : DEFAULT_PRACTICE_PULSE_PERIOD;

export const getPracticePulseDateRange = (
    period: PracticePulsePeriod,
    today: Date = new Date(),
): PracticePulseDateRange => {
    switch (period) {
        case 'YTD':
            return { from: startOfYear(today), to: today };
        case 'Past 7 Days':
            return { from: subDays(today, 6), to: today };
        case 'Past 30 Days':
            return { from: subDays(today, 29), to: today };
        case 'Past 12 Months':
            return { from: addDays(subYears(today, 1), 1), to: today };
        case 'This Quarter':
            return { from: startOfQuarter(today), to: today };
        case 'Last Quarter': {
            const lastQuarter = subQuarters(today, 1);
            return { from: startOfQuarter(lastQuarter), to: endOfQuarter(lastQuarter) };
        }
        case 'Last Year': {
            const lastYear = subYears(today, 1);
            return { from: startOfYear(lastYear), to: endOfYear(lastYear) };
        }
    }
};
